import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import userReducer from './slices/user';
import requestReducer from './slices/request';
import lawyerReducer from './slices/lawyer';
import clientReducer from './slices/client';
import calendarReducer from './slices/calendar';
import availabilityReducer from './slices/availability';
import appointmentReducer from './slices/appointment';
import categoriesReducer from './slices/categories';
import packagesReducer from './slices/packages';
import classesReducer from './slices/classes';
import complaintsReducer from './slices/complaints';
import promotionsReducer from './slices/promotions';
import featureReducer from './slices/features';
import reportReducer from './slices/report';
import tabReducer from './slices/Tab';
import employeeReducer from './slices/employee';
import musherReducer from './slices/musher';
import b2bReducer from './slices/b2b';
import permissionReducer from './slices/permission';
import filesReducer from './slices/files';

import chatReducer from './slices/chat';
import blogReducer from './slices/blogs';
import scheduleDemoReducer from './slices/scheduleDemo';
import B2bCustomer from './slices/B2BCustomers';
import MasterCategory from './slices/masterCategories';
import NewsSlice from "./slices/news"

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const rootReducer = combineReducers({
  user: userReducer,
  request: requestReducer,
  lawyer: lawyerReducer,
  musher: musherReducer,
  b2b: b2bReducer,
  client: clientReducer,
  calendar: calendarReducer,
  availability: availabilityReducer,
  appointment: appointmentReducer,
  categories: categoriesReducer,
  packages: packagesReducer,
  classes: classesReducer,
  complaints: complaintsReducer,
  promotions: promotionsReducer,
  features: featureReducer,
  report: reportReducer,
  tab: tabReducer,
  employee: employeeReducer,
  permission: permissionReducer,
  files: filesReducer,
  chat: chatReducer,
  blog: blogReducer,
  scheduleDemo: scheduleDemoReducer,
  B2BCustomers: B2bCustomer,
  MasterCategory: MasterCategory,
  NewsSlice: NewsSlice
});

export { rootPersistConfig, rootReducer };
